import { Component } from 'src/utils';
import homeArrow from './../../../images/home-arrow.png';
import logoIcon from './../../../images/small-logo.png';
import houseIcon from './../../../images/house-icon.png';
import template from './cart.html';
import closeIcon from './../../../images/close.png';
import alertIcon from './../../../images/alert.png';
import shippingOfferInfoIcon from './../../../images/shipping-info.png';
import shippingOfferAvailableIcon from './../../../images/shipping-tick.png';
import { isError } from 'lodash';

@Component({
  controllerAs: 'cart',
  template
})

export default class Cart {

  static $inject = [
    '$scope',
    '$rootScope',
    '$ngRedux',
    'spinnerService',
    'authService',
    'orderService',
    '$state',
    '$uibModal',
    '$timeout',
      '$window',
      '$stateParams',
      'APP',
      'toaster'
  ];

  constructor($scope,$rootScope, $ngRedux, $spinner, $auth, $order, $state, $uibModal,$timeout,$window,$stateParams, APP, toaster) {
    const disconnect = $ngRedux.connect(this.mapState)(this);

    this.dscMasterCode = '88888888'; // Named constant
    this.$window= $window;
    this.APP = APP;
    this.$auth = $auth;
    this.$state = $state;
    this.$order = $order;
    this.$scope=$scope;
    this.$toaster = toaster;
    this.homeArrow = homeArrow;
    this.logoIcon = logoIcon;
    this.$stateParams = $stateParams; 
    this.houseIcon = houseIcon;
    this.closeIcon = closeIcon;
    this.alertIcon = alertIcon;
    this.$rootScope = $rootScope;
    this.shippingOffer = {};
    this.shippingOffer.isOfferAvailable = false;
    this.shippingOffer.isOfferEligible = false;
    this.couponAmount = 0;
    this.taxableDiscountAmount = 0;
    this.discountCouponAmount=0;
    this.discountCode = null;
    this.discountType =null;
    this.isMiscelleneousCategory = 4;
    this.giftCardMasterCodeStartsWith = '9';
    this.appliedDiscountCoupon=  sessionStorage.getItem('discountCoupon');
    this.appliedBirdBuckCoupon=  sessionStorage.getItem('birdbuckCoupon');
    this.erplyBBCouponDiscount = sessionStorage.getItem('erplyBBDiscount');
    this.erplyPromotionDiscount = sessionStorage.getItem('erplyPromotionDiscount');
    console.log("this.erplyBBCouponDiscount : ", this.erplyBBCouponDiscount);
    console.log("this.appliedErplyPromotionDiscount : ", this.erplyPromotionDiscount);
    this.isValidToApplyPromo = true;
    this.baseMicroSecs = 500;
    this.startMicroSecs = 500;
    this.addMicroSecs = 600;
    this.hasErplyCalShopcartRes=false;
    this.$spinner=$spinner;
    this.dscDiscount = 'dscdiscount';
    this.dscPercentage = 'dscpercentage';
    this.dscDiscountedPrice = 'dscDiscountedPrice';
    this.loadCartPageOnce = 1;
    this.numberOfItemsAllowedToPurchase = 40;
    this.doPageNeedsToBeRefreshed = false;
    //
    this.addressDetail = {};
    this.promoLengthToBeShown=25;
    var $ctrl= this;
    
    // this.addressDetail.shippingState ? this.addressDetail.shippingState.code : ''
 
    //
    
    var shipToStateId;
    $spinner.show('appSpinner');
    var userProfile = this.$auth.getUserProfile().then(success => {
      let addressObj = localStorage.getItem('deliveryAddress');
      this.addressDetail = addressObj ? JSON.parse(addressObj) : success.data;
      if(this.appliedDiscountCoupon){
        var isInStorePickUp = true;
        if(this.$rootScope.tempdeliveryMode){
          if(this.$rootScope.tempdeliveryMode!==''){
            isInStorePickUp = this.$rootScope.tempdeliveryMode==='In Store Pickup'?true:false;
            shipToStateId = this.getShipToStateId(isInStorePickUp);
          } else {
            shipToStateId = this.getShipToStateId(true);
          }
        } else {
          shipToStateId = this.getShipToStateId(true);
        }
        
        this.$order.getCouponDiscount(this.appliedDiscountCoupon,isInStorePickUp,shipToStateId).then(() => {
          this.calculateDiscounts();
          this.validatePromoCoupon();
        })
        .catch(err => {
          this.discountCouponAmount=0;
          this.$auth.printCustomerGenericLogs(err);
        });
      }
      if(this.appliedBirdBuckCoupon){
        this.$order.getBirdBuckCoupon(this.appliedBirdBuckCoupon).then(() => {
          this.couponAmount = this.coupon.bbCouponAmount;
          this.validateBBCoupon();
        })
        .catch(err => {
          this.couponAmount = 0;
          this.$auth.printCustomerGenericLogs(err);
        });
      }
      // $spinner.hide('appSpinner');
    })
    .catch(err => {
      this.$auth.printCustomerGenericLogs(err);
    })
    .finally(() =>  {
      $spinner.hide('appSpinner');
    });
    
    
    this.shippingOffer.thresholdAmount = 1500;
    this.shippingOfferInfoIcon = shippingOfferInfoIcon;
    this.shippingOfferAvailableIcon = shippingOfferAvailableIcon;
    this.maxPrice = 0;
    this.maxPriceId = 0;
    this.discountPercentage = 0.00;
    this.$uibModal = $uibModal;
    this.erplyDis = [];
    $window.scrollTo(0, 0);
    // $spinner.show('appSpinner');
    $order.getStoreDiscountMapping();
    
    console.log("this.profile--",this.profile);
    var bbCoupon = [];
    if(sessionStorage.getItem('erplyBBCouponCodes')) {
      bbCoupon = sessionStorage.getItem('erplyBBCouponCodes').split(',');
    }
    var promoCoupon = [];
    if(sessionStorage.getItem('erplyPromotionCodes')) {
      promoCoupon = sessionStorage.getItem('erplyPromotionCodes').split(',');
    }
    let customerId = null;
    if (this.profile.customer) {
      customerId = this.profile.customer.id;
    }
    let cartDetails = {
      "isGuestUser" : this.profile.isGuest,
      "checkForShippingTax" : false,
      "isDiscountApplied" : promoCoupon.length > 0 ? true : false,
      "manualPromotionIDs" : promoCoupon ? promoCoupon : null,
      "couponIdentifiers" : bbCoupon ? bbCoupon : null,
      "customerId" : customerId
      };
    userProfile.then(() => {
      $spinner.show('appSpinner');
        if($ctrl.profile.store && !$ctrl.profile.store.hasErply){
          $order.getCartDetail()
          .finally(() => {
            $spinner.hide('appSpinner');
          });
        } else {
            $order.getErplyCartDetail(cartDetails).then(success => {
              if(success.data) {
                if(success.data.itemToBeRemovedFromCart) {
                  this.doPageNeedsToBeRefreshed = true;
                  var title = "Some Items removed from cart due to an internal issue";
                  var detailInfo = "Item(s) : \n";
                  if(success.data.itemToBeRemovedFromCart.hasItemsToRemoveFromCart) {
                    for(var i=0; i<success.data.itemToBeRemovedFromCart.itemsToBeRemoved.length; i++) {
                      detailInfo = detailInfo + success.data.itemToBeRemovedFromCart.itemsToBeRemoved[i].itemName;
                      if((i+1)<success.data.itemToBeRemovedFromCart.itemsToBeRemoved.length) {
                        detailInfo = detailInfo + ",";
                      }
                    }
                    this.$uibModal.open( {
                      size: 'sm',
                      backdrop: 'static',
                      keyboard: false,
                      template: '<div class="modal-body" id="modal-body">' +
                      '<h5 class="font-weight-bold">' + title + '</h5>' +
                      detailInfo +
                      '</div>' +
                      '<div class="modal-footer">' +
                      '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' +
                      '</div>',
                      controller: ['$scope', 'orderService', '$uibModalInstance', '$window',
                        function($scope, $order, $uibModalInstance,$window) {
                          $scope.ok = () => {
                            $window.location.reload();
                            $uibModalInstance.close();
                          };
                        }
                      ],
                      resolve: {
                      }
                    });
                  } else {
                    this.doPageNeedsToBeRefreshed = false;
                  }
                }
              }
              if($ctrl.cartContainsDsc()){
                $ctrl.$order.dscPremembership().then(sucess1 => {
                  if($ctrl.loadCartPageOnce==1){
                    $spinner.show('appSpinner');
                    $ctrl.loadCartPageOnce=$ctrl.loadCartPageOnce+1;
                    $order.getErplyCartDetail(cartDetails).then(success2 => {
                    }).finally(() => 
                    {
                      $ctrl.setErplyCartResponseValue();
                      $spinner.hide('appSpinner');
                      // $ctrl.$auth.getUserProfile();
                    });
                  }
                }
                );
              } else {
                $ctrl.setErplyCartResponseValue();
                $spinner.hide('appSpinner');
              }
              console.log('this.erplyDis', $ctrl.erplyDis);
              console.log('this.detail.erplyPromoAndDiscount',$ctrl.detail.erplyPromoAndDiscount);
              $spinner.hide('appSpinner');
            })
            .catch(err => {
              $spinner.hide('appSpinner');
            });
      }
    })
    .catch(err => {
      this.$auth.printCustomerGenericLogs(err);
    })
    .finally(() => 
        {
          $ctrl.calculateDiscounts();
          $ctrl.calculateClubPoints();
          // $spinner.hide('appSpinner');
          // $ctrl.$auth.getUserProfile();
      });
    
    
    this.currencyType = 'USD';
    $timeout(() => {
      if(this.profile.store){
        this.isErplyStore = this.profile.store.hasErply;
        this.country = (this.profile.store.country && this.profile.store.country.countryCode)?this.profile.store.country.countryCode:'US';
        this.currencyType=$order.getCurrencyType(this.country);
      }
    },800);
    $scope.$on('$destroy', disconnect);
  }
  mapState(state) {

    return {
      profile: state.auth.profile,
      detail: state.order.cartDetail,
      discountCoupon : state.order.discountCoupon,
      coupon: state.order.coupon,
      storeDiscountMap : state.order.storeDiscountMap,
      orderPoints: state.order.orderPoints
    };
  }

  getRetailPrice(quantity, price) {
    return quantity * price;
  }

  getClubDiscount(quantity, price) {
    return this.getRetailPrice(quantity, price) - this.getDiscountedPrice(quantity, price);
  }

  getDiscountedPrice(quantity, price) {
    return quantity * (Math.round((0.85 * price) * 100) / 100);
  }

  goToHomePage() {
    let storeName = '';
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    } else {
      if (this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if (storeName) {
      this.$window.location.href = '/' + storeName;
    } else {
      this.$state.go('home');
    }
  }

  getMaxItemDiscount(discount, price) {
    
    return  (Math.round((discount * price/100) * 100) / 100);
  }

  totalRetailPrice() {
    return this.detail.cartItems.map(item => item.item.price * item.quantity)
      .reduce((prev, curr) => prev + curr);
  }

  getSavedAmount(){
    return this.getSubtotal()-this.getDSCAmount();
  }

  getErplySaveAmount() {
    return this.detail.erplyShopCartResponse.originalPriceTotal - this.getDSCAmount();
  }

  getDSCAmount(){
    let totalPrice = 0;
    if(this.appliedDiscountCoupon && this.discountCoupon.enabled && !this.discountCoupon.expired
       && this.discountCoupon.discountType === 'HIGHPERCENTAGE') {
        if(this.discountCoupon.discountType === 'HIGHPERCENTAGE') {
          var maxPrice = 0;
          var maxPriceId = 0;
          var isDscMember = true;
           angular.forEach(this.detail.cartItems, function(item, key) {
            // console.log(key);
            if(item.item.masterProduct.isDiscountable && item.item.price > maxPrice){
                maxPriceId = item.item.id;
                maxPrice = item.item.price;
              }
            });

            angular.forEach(this.detail.cartItems, function(item, key) {
              // console.log(key);
             if(maxPriceId === item.item.id){
                if(item.subCategory.category.dscCategory && isDscMember) {
                 totalPrice = totalPrice + ((Math.round((0.85 * item.item.price) * 100) / 100) * (item.quantity-1));
                }
                totalPrice =  totalPrice + item.item.price;
              }
              else{
                if(item.subCategory.category.dscCategory && isDscMember) {
                totalPrice = totalPrice + ((Math.round((0.85 * item.item.price) * 100) / 100) * item.quantity);
                }
              }
            });
          }
    }
    else{
        let dscItems = this.detail.cartItems.filter(item => item.subCategory.category.dscCategory);
        let dscTotal = dscItems.map(item => (Math.round((0.85 * item.item.price) * 100) / 100) * item.quantity)
          .reduce((prev, curr) => prev + curr, 0);
        let nondscItems = this.detail.cartItems.filter(item => !item.subCategory.category.dscCategory);
        let nonDscTotal = nondscItems.map(item => item.item.price * item.quantity)
          .reduce((prev, curr) => prev + curr, 0);
        totalPrice = dscTotal + nonDscTotal;
    }
    return totalPrice;
  }

  isCartHasDSCItems() {
    let dscItems = this.detail.cartItems.filter(item => item.subCategory.category.dscCategory);
    if(dscItems.length>0){
      return true;
    }else{
      return false;
    }
  }

  getCouldSaveDSCPrice(){
    let totalPrice = 0;
    let dscItems = this.detail.cartItems.filter(item => item.subCategory.category.dscCategory);
        let dscTotal = dscItems.map(item => (Math.round((0.15 * item.item.price) * 100) / 100) * item.quantity)
          .reduce((prev, curr) => prev + curr, 0);
        let nondscItems = this.detail.cartItems.filter(item => !item.subCategory.category.dscCategory);
        let nonDscTotal = nondscItems.map(item => item.item.price * item.quantity)
          .reduce((prev, curr) => prev + curr, 0);
        totalPrice = dscTotal + nonDscTotal;
    return totalPrice;
  }

  getSubtotal() {
    let totalPrice = 0;
    if(this.profile.store.hasErply){
      // console.log("This erplyShop : ", this.detail.erplyShopCartResponse);
      totalPrice = this.detail.erplyShopCartResponse.subTotal; // subtotal has promotions and BB discounted
    }
    if(this.appliedDiscountCoupon && this.discountCoupon.enabled && !this.discountCoupon.expired && this.discountCoupon.discountType === 'HIGHPERCENTAGE') {
        if(this.discountCoupon.discountType === 'HIGHPERCENTAGE') {
          var maxPrice = 0;
          var maxPriceId = 0;
          var isDscMember = this.isDscMember() || this.cartContainsDsc();
           angular.forEach(this.detail.cartItems, function(item, key) {
            // console.log(key);
            if(item.item.masterProduct.isDiscountable && item.item.price > maxPrice){
                maxPriceId = item.item.id;
                maxPrice = item.item.price;
              }
            });

            angular.forEach(this.detail.cartItems, function(item, key) {
              // console.log(key);
             if(maxPriceId === item.item.id){
                if(item.subCategory.category.dscCategory && isDscMember) {
                 totalPrice = totalPrice + ((Math.round((0.85 * item.item.price) * 100) / 100) * (item.quantity-1));
                }
                else {
                totalPrice = totalPrice + (item.item.price * (item.quantity-1));  
                }
                totalPrice =  totalPrice + item.item.price;
              }
              else{
                if(item.subCategory.category.dscCategory && isDscMember) {
                totalPrice = totalPrice + ((Math.round((0.85 * item.item.price) * 100) / 100) * item.quantity);
                }
                else {
                totalPrice = totalPrice + (item.item.price * item.quantity);  
                }
              }
            });
           
          }
    }
    else{
        if (this.isDscMember() || this.cartContainsDsc()) {
        let dscItems = this.detail.cartItems.filter(item => item.subCategory.category.dscCategory);
        let dscTotal = dscItems.map(item => (Math.round((0.85 * item.item.price) * 100) / 100) * item.quantity)
          .reduce((prev, curr) => prev + curr, 0);
        let nondscItems = this.detail.cartItems.filter(item => !item.subCategory.category.dscCategory);
        let nonDscTotal = nondscItems.map(item => item.item.price * item.quantity)
          .reduce((prev, curr) => prev + curr, 0);
        totalPrice = dscTotal + nonDscTotal;
      }
      else {
        totalPrice = this.totalRetailPrice();
      }

    }
    return totalPrice;
  }

  getTotalSaving() {
    return this.totalRetailPrice() - this.getSubtotal() + this.calculateDiscounts();
  }

 calculateDiscounts() {
  if(this.appliedDiscountCoupon)
  {
    if(this.discountCoupon.enabled && !this.discountCoupon.expired) {
      var discountCouponAmount = 0;
      var discountPer = 0;
      var discountTotalAmount = 0; 
      var isDscMember = this.isDscMember() || this.cartContainsDsc();
        if(this.discountCoupon.discountType === 'HIGHPERCENTAGE') {
          var maxPrice = 0;
          var maxPriceId = 0;
          discountPer = this.discountCoupon.discountPercentage;
          this.discountType = this.discountCoupon.discountType;
           angular.forEach(this.detail.cartItems, function(item, key) {
          // console.log(key);
            if(item.item.masterProduct.isDiscountable && item.item.price > maxPrice){
                maxPriceId = item.item.id;
                maxPrice = item.item.price;
                discountCouponAmount =  (Math.round((discountPer * maxPrice/100) * 100) / 100);
              }
            });
          
           this.maxPriceId = maxPriceId; 
           this.discountPercentage = this.discountCoupon.discountPercentage;
           this.discountCouponAmount = discountCouponAmount;
          }

          if(this.discountCoupon.discountType === 'SUBCATEGORY') {
          this.discountType = this.discountCoupon.discountType;
          var dscDiscountPer = this.discountCoupon.dscDiscountPercentage;
          var nonDSCDiscountPer = this.discountCoupon.nonDscDiscountPercentage;
          
          var subCategoriesList = this.discountCoupon.subCategories;
           angular.forEach(this.detail.cartItems, function(item, key) {
            // console.log(key);
            if(item.item.masterProduct.isDiscountable && item.subCategory.category.dscCategory && isDscMember) {
              for(var i = 0; i < subCategoriesList.length; i++) {
                for(var j = 0; j < item.item.masterProduct.subCategories.length; j++){
                  if (subCategoriesList[i].id ===  item.item.masterProduct.subCategories[j].id) {
                    discountTotalAmount = discountTotalAmount+ (item.item.price * item.quantity);
                    discountCouponAmount =  (Math.round((dscDiscountPer * discountTotalAmount/100) * 100) / 100);
                }
                }
                
              }   
            } 
            else if (item.item.masterProduct.isDiscountable){
                 for(var k = 0; k < subCategoriesList.length; k++) {
                   for(var l = 0; l < item.item.masterProduct.subCategories.length; l++){
                    if (subCategoriesList[k].id ===  item.item.masterProduct.subCategories[l].id) {
                    discountTotalAmount = discountTotalAmount+ (item.item.price * item.quantity);
                    discountCouponAmount =  (Math.round((dscDiscountPer * discountTotalAmount/100) * 100) / 100);
                }
                }
                } 
            }
            });
           this.discountCouponAmount = discountCouponAmount;
          }


           if(this.discountCoupon.discountType === 'PERCENTAGE') {
          this.discountType = this.discountCoupon.discountType;
          
          discountPer = this.discountCoupon.discountPercentage;
           angular.forEach(this.detail.cartItems, function(item, key) {
            // console.log(key);
              if(item.item.masterProduct.isDiscountable && item.subCategory.category.dscCategory && isDscMember) {
                    discountTotalAmount = discountTotalAmount+ ((Math.round((0.85 * item.item.price) * 100) / 100) * item.quantity);
                    discountCouponAmount =  (Math.round((discountPer * discountTotalAmount/100) * 100) / 100);
                
              } 
             else if (item.item.masterProduct.isDiscountable){  
                    discountTotalAmount = discountTotalAmount+ (item.item.price *item.quantity);
                    discountCouponAmount =  (Math.round((discountPer * discountTotalAmount/100) * 100) / 100);
              }
           });
           this.discountCouponAmount = discountCouponAmount;
          }

          if(this.discountCoupon.discountType === 'AMOUNT') {
           this.discountType = this.discountCoupon.discountType;
           this.discountCouponAmount = this.discountCoupon.couponAmount;
          }
          if(this.discountCoupon.discountType === 'FREEITEM') {
           this.discountType = this.discountCoupon.discountType;
           this.discountCouponAmount = this.discountCoupon.couponAmount;
          }
          if(this.discountCoupon.discountType === 'BUYXGETY') {
            this.discountType = this.discountCoupon.discountType;
            this.discountCouponAmount = this.discountCoupon.couponAmount;
          }
      }
    }
    return this.discountCouponAmount;
    
 }
  // DSC Points is equal to subtotal (Price - discount).
  getDscPoints() {
    return ( this.getSubtotal() - this.calculateDiscounts());
  }


  updateItemInCart(quantity, item) {
    // console.log(item);
    var ctrl = this;
    ctrl.startMicroSecs = ctrl.startMicroSecs+ctrl.addMicroSecs;
    // console.log("ctrl.startMicroSecs : ",ctrl.startMicroSecs);
    this.$order.updateItemInCart(quantity, item.item.id, item.item.masterProduct.subCategories[0].id)
      .then(() => {
        this.calculateClubPoints();
        var bbCoupon = [];
        if(sessionStorage.getItem('erplyBBCouponCodes')) {
          bbCoupon = sessionStorage.getItem('erplyBBCouponCodes').split(',');
        }
        var promoCoupon = [];
        if(sessionStorage.getItem('erplyPromotionCodes')) {
          promoCoupon = sessionStorage.getItem('erplyPromotionCodes').split(',');
        }
        let customerId = null;
        if (this.profile.customer) {
          customerId = this.profile.customer.id;
        }
        let cartDetails = {
          "isGuestUser" : this.profile.isGuest,
          "checkForShippingTax" : false,
          "isDiscountApplied" : promoCoupon.length > 0 ? true : false,
          "manualPromotionIDs" : promoCoupon ? promoCoupon : null,
          "couponIdentifiers" : bbCoupon ? bbCoupon : null,
          "customerId" : customerId
          };
        if(this.profile.store && this.profile.store.hasErply){
          if(!this.hasErplyCalShopcartRes){
            ctrl.hasErplyCalShopcartRes=true;
            setTimeout(function(){
              // console.log("Inside set time ctrl.startMicroSecs : ",ctrl.startMicroSecs);
              ctrl.$spinner.show('appSpinner');
              ctrl.$order.getErplyCartDetail(cartDetails).then(() => {
                ctrl.setErplyCartResponseValue();
                ctrl.hasErplyCalShopcartRes=false;
                ctrl.$spinner.hide('appSpinner');
                ctrl.startMicroSecs=ctrl.baseMicroSecs;
              })
              .catch(() => {
                ctrl.hasErplyCalShopcartRes=false;
                ctrl.startMicroSecs=ctrl.baseMicroSecs;
                ctrl.$spinner.hide('appSpinner');
              });
            },ctrl.startMicroSecs);
            // console.log("After set time call, ctrl.startMicroSecs: ", this.startMicroSecs);
          }
        } else {
          ctrl.$order.getCartDetail();
        }
        this.$auth.getUserProfile();
      })
      .catch(err => {
        this.$auth.printCustomerGenericLogs(err);
      })
      ;
  }

  removeItemFromCart(itemId) {
    var ctrl = this;
    ctrl.startMicroSecs = ctrl.startMicroSecs+ctrl.addMicroSecs;
    // console.log("ctrl.startMicroSecs : ",ctrl.startMicroSecs);
    this.$order.removeItemFromCart(itemId)
      .then(() => {
        if (ctrl.appliedDiscountCoupon && ctrl.discountFreeItemId && ctrl.discountFreeItemId === itemId) {
          sessionStorage.removeItem('discountCoupon');
          ctrl.appliedDiscountCoupon = null;
        }
        this.calculateClubPoints();
        var bbCoupon = [];
        if(sessionStorage.getItem('erplyBBCouponCodes')) {
          bbCoupon = sessionStorage.getItem('erplyBBCouponCodes').split(',');
        }
        var promoCoupon = [];
        if(sessionStorage.getItem('erplyPromotionCodes')) {
          promoCoupon = sessionStorage.getItem('erplyPromotionCodes').split(',');
        }
        let customerId = null;
        if (this.profile.customer) {
          customerId = this.profile.customer.id;
        }
        let cartDetails = {
          "isGuestUser" : this.profile.isGuest,
          "checkForShippingTax" : false,
          "isDiscountApplied" : promoCoupon.length > 0 ? true : false,
          "manualPromotionIDs" : promoCoupon ? promoCoupon : null,
          "couponIdentifiers" : bbCoupon ? bbCoupon : null,
          "customerId" : customerId
          };
        if(this.profile.store.hasErply){
          if(!this.hasErplyCalShopcartRes){
            ctrl.hasErplyCalShopcartRes=true;
            const dscItem = ctrl.getDSCItemFromCart();
            if (dscItem && dscItem.id == itemId) {
              ctrl.$order.deleteDscPremembership();
            }
            setTimeout(function(){
              ctrl.$spinner.show('appSpinner');
              ctrl.$order.getErplyCartDetail(cartDetails).then(() => {
                ctrl.setErplyCartResponseValue();
                ctrl.hasErplyCalShopcartRes=false;
                ctrl.startMicroSecs=ctrl.baseMicroSecs;
                ctrl.$spinner.hide('appSpinner');
              })
              .catch(() => {
                ctrl.hasErplyCalShopcartRes=false;
                ctrl.startMicroSecs=ctrl.baseMicroSecs;
                ctrl.$spinner.hide('appSpinner');
              });
            },ctrl.startMicroSecs);
          }
        } else {
          ctrl.$order.getCartDetail();
        }
        this.$auth.getUserProfile();
      })
      .catch(err => {
        this.$auth.printCustomerGenericLogs(err);
      });
  }

  updateItemInCart_old(quantity, item) {
    // console.log(item);
    var ctrl = this;
    this.$order.updateItemInCart(quantity, item.item.id, item.item.masterProduct.subCategories[0].id)
      .then(() => {
        this.calculateClubPoints();
        ctrl.$order.getCartDetail();
        this.$auth.getUserProfile();
      })
      .catch(err => {
        this.$auth.printCustomerGenericLogs(err);
      });
  }

  removeItemFromCart_old(itemId) {
    this.$order.removeItemFromCart(itemId)
      .then(() => {
        this.calculateClubPoints();
        this.$order.getCartDetail();
        this.$auth.getUserProfile();
      }).catch(err => {
        this.$auth.printCustomerGenericLogs(err);
      });
  }

  isDscMember() {
    if (!this.profile.customer) return false;
    return this.profile.customer.dscId === 'C' && new Date() <= new Date(this.profile.customer.dscExpireDate);
  }

  isDscButExpired() {
    if (!this.profile.customer) return false;
    return this.profile.customer.dscId === 'C' && new Date() > new Date(this.profile.customer.dscExpireDate);
  }

  canUserJoin() {
    return (!(this.isDscMember() || this.isDscButExpired()));
  }

  isAnyItemInactive() {

    const arr = this.detail?this.detail.cartItems.filter(item => !(item.item.isActive 
      && item.item.masterProduct.isActive && item.item.price!=0 && (item.item.price >= item.item.regionalPrice) && !item.item.isOutOfStock)):[];
    return !(arr.length === 0);
  }

  cartContainsDsc() {
    const arr = this.detail?this.detail.cartItems.filter(item => item.item.masterProduct.masterCode === this.dscMasterCode):[];
    return (arr.length === 1);
  }

  goToDetailPage(item) {
    if (this.isItemDscMembership(item)) {
      this.$state.go('savings-club');
    }
    else {
      let storeName = '';
      if(this.$stateParams.storeName) {
        storeName = this.$stateParams.storeName;
      }
      else {
        if(this.profile.store && this.profile.store.storeName) {
          storeName = this.profile.store.storeURLName;
        } else {
         storeName = this.$auth.getGuestStoreDetail().storeName;
        }
      }
      // let storeName =  false;
      if (storeName) {
        this.$state.go('browse-product.detail', {
          categoryId: item.item.masterProduct.category.prettyUrl, 
          subCategoryId: item.item.masterProduct.subCategories[0].prettyUrl, 
          productId: item.item.masterProduct.prettyUrl,
          itemGroupNumber: item.item.masterProduct.itemGroupNumber,
          storeName: storeName
         });
      }
      else {
        this.$state.go('browse-product.detail', {
          categoryId: item.item.masterProduct.category.prettyUrl, 
          subCategoryId: item.item.masterProduct.subCategories[0].prettyUrl, 
          productId: item.item.masterProduct.prettyUrl,
          itemGroupNumber: item.item.masterProduct.itemGroupNumber
         });
      }
    }
  }

  isItemDscMembership(item) {
    return item.item.masterProduct.masterCode === this.dscMasterCode;
  }

  isItemActive(item) {
    return (item.item.isActive && item.item.masterProduct.isActive && item.item.price!=0 && (item.item.price >= item.item.regionalPrice) && !item.item.isOutOfStock);
  }

  isFreeShippingOfferAvailable() {
    if (this.profile && this.detail.freeshipping) {
      var shippingOfferStartDate = new Date(this.detail.freeshipping.startDate);
      var shippingOfferEndDate = new Date(this.detail.freeshipping.endDate);
      var currentDate = new Date();
      var result = false;
      if (this.profile.store) {
        if (this.profile.store.isFreeShipping) {
          if (currentDate >= shippingOfferStartDate && currentDate <= shippingOfferEndDate) {
            result = true;
          }
        }
      }

    }
    return result;
  }

  shippingGrossPrice() {
    var totalGiftCardAmountPurchasing = 0.00;
    var $ctrl = this;
    angular.forEach(this.detail.cartItems, function(item, key) {
      if(item.item.masterProduct.category.id === $ctrl.isMiscelleneousCategory && 
        item.item.masterProduct.masterCode.charAt(0) === $ctrl.giftCardMasterCodeStartsWith){
          totalGiftCardAmountPurchasing = totalGiftCardAmountPurchasing + (item.item.price * item.quantity);
        }
      });
      if(this.profile.store.hasErply){
        return this.getSubtotal() - totalGiftCardAmountPurchasing;
      } else {
        return this.getSubtotal() - totalGiftCardAmountPurchasing - this.couponAmount - this.discountCouponAmount;
      }
  }
  
  getFreeShippingRemainingAmount() {
    if (this.detail ) {
      if (this.detail.freeshipping) {
        this.shippingOffer.thresholdAmount = this.detail.freeshipping.thresholdValue;
      }
    }
    let remainingAmount = this.shippingGrossPrice() - this.shippingOffer.thresholdAmount;
    if (remainingAmount >= 0) {
      this.shippingOffer.isOfferEligible = true;
    }
    else {
      this.shippingOffer.isOfferEligible = false;
    }
    return remainingAmount * -1;
  }
  showFreeShippingOfferDetail() {
    var $ctrl = this;
    var detailInfo, tittle = '';
    if ($ctrl.shippingOffer.isOfferEligible) {
      detailInfo = '<p><ul><li>Offer available within Zone 2 shipping, approximately 150 miles from store. Additional zones will incur additional charges.</li><li>Offer is valid only on orders placed at MyWBU Store, is limited to stock on hand, and is not redeemable for cash.</li><li>Offer limited to standard shipping to U.S. Addresses only.</li><li>Offer is valid on all orders with a subtotal of $' + $ctrl.shippingOffer.thresholdAmount + ' or more after any other discounts applied.</li></ul></p>';
      tittle = 'Free Shipping within Zone 2';
    }
    else {
      tittle = 'Free Shipping within Zone 2';
      detailInfo = '<p><ul><li>Offer available within Zone 2 shipping, approximately 150 miles from store. Additional zones will incur additional charges.</li><li>Offer is valid only on orders placed at MyWBU Store, is limited to stock on hand, and is not redeemable for cash.</li><li>Offer limited to standard shipping to U.S. Addresses only.</li><li>Offer is valid on all orders with a subtotal of $' + $ctrl.shippingOffer.thresholdAmount + ' or more after any other discounts applied.</li></ul></p>';
    }
    this.$uibModal.open( {
      size: 'sm',
      template: '<div class="modal-body" id="modal-body">' +
      '<h5 class="font-weight-bold">' + tittle + '</h5>' +
      detailInfo +
      '</div>' +
      '<div class="modal-footer">' +
      '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' +
      '</div>',
      controller: ['$scope', 'orderService', '$uibModalInstance',
        function($scope, $order, $uibModalInstance) {

          $scope.ok = () => {
            $uibModalInstance.close();

          };

        }
      ]
    });
  }

  showFreeShippingOfferDetailCan() {
    var $ctrl = this;
    var detailInfo, tittle = '';
    if ($ctrl.shippingOffer.isOfferEligible) {
      detailInfo = '<p><ul><li>Offer is valid within Zones 0-1 as defined by FedEx. Additional zones will incur additional charges.</li><li>Offer is valid only on orders placed at MyWBU Store, is limited to stock on hand, and is not redeemable for cash.</li><li>Offer limited to standard shipping to Canadian addresses only</li><li>Offer is valid on all orders with a subtotal of $' + $ctrl.shippingOffer.thresholdAmount + ' or more after any other discounts applied.</li></ul></p>';
      tittle = 'Free shipping in Zones 0-1';
    }
    else {
      tittle = 'Free shipping in Zones 0-1';
      detailInfo = '<p><ul><li>Offer is valid within Zones 0-1 as defined by FedEx. Additional zones will incur additional charges.</li><li>Offer is valid only on orders placed at MyWBU Store, is limited to stock on hand, and is not redeemable for cash.</li><li>Offer limited to standard shipping to Canadian addresses only</li><li>Offer is valid on all orders with a subtotal of $' + $ctrl.shippingOffer.thresholdAmount + ' or more after any other discounts applied.</li></ul></p>';
    }
    this.$uibModal.open( {
      size: 'sm',
      template: '<div class="modal-body" id="modal-body">' +
      '<h5 class="font-weight-bold">' + tittle + '</h5>' +
      detailInfo +
      '</div>' +
      '<div class="modal-footer">' +
      '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' +
      '</div>',
      controller: ['$scope', 'orderService', '$uibModalInstance',
        function($scope, $order, $uibModalInstance) {

          $scope.ok = () => {
            $uibModalInstance.close();

          };

        }
      ]
    });
  }


  isDscAddedinCart(){
    return this.detail.cartItems.some(function (cartItem) {
      return cartItem.item.storeItemCode === 'C';
    });
  }


  getClubPoints(){
    let points = 0;
    let tempPoints = 0;
    // For HighPercentage discount points will be calculated in getPoints method
    if(this.appliedDiscountCoupon && this.discountCoupon.enabled && !this.discountCoupon.expired && this.discountCoupon.discountType === 'HIGHPERCENTAGE'){
      points = this.getPoints(this.storeDiscountMap);
    }
    else {
      let promoAmount = this.calculateDiscounts();
      tempPoints = this.getPoints(this.storeDiscountMap);
      if(tempPoints >= promoAmount && this.isValidToApplyPromo){
        points = tempPoints - promoAmount;
      } else {
        points = tempPoints;
      }
    } 
    if(this.isValidToApplyBB && points >= this.couponAmount){
        points = points - this.couponAmount;
    }
    return points;
  }

  getPoints(storeDiscountMap) {
    let points = 0;
    let dscTotal = 0;
    let nonDscTotal = 0;
    var $ctrl = this;
    // update
    if(this.appliedDiscountCoupon && this.discountCoupon.enabled && !this.discountCoupon.expired && this.discountCoupon.discountType === 'HIGHPERCENTAGE') {
      if(this.discountCoupon.discountType === 'HIGHPERCENTAGE') {
        let promoAmount = Math.round(this.calculateDiscounts()*100)/100;
        
        var maxPrice = 0;
        var maxPriceId = 0;
        var isDscMember = this.isDscMember() || this.cartContainsDsc();
         angular.forEach(this.detail.cartItems, function(item, key) {
          // console.log(key);
          if(item.item.masterProduct.isDiscountable && item.item.price > maxPrice){
              maxPriceId = item.item.id;
              maxPrice = item.item.price;
            }
          });
          
          angular.forEach(this.detail.cartItems, function(item, key) {
            // console.log(key);
            // console.log("High Percentage promo: Item id for " +maxPriceId + " Item Price : " + maxPrice);
           if(maxPriceId === item.item.id){
              if(item.item.masterProduct.applyDscPoints){
                if(storeDiscountMap.status && item.item.masterProduct.applyDoubleDSCPoints){
                  if(item.subCategory.category.dscCategory){
                    points = points+(Math.round($ctrl.doubleTheValue(0.85 * item.item.price) * 100) / 100) * (item.quantity-1);
                    points = points+(Math.round($ctrl.doubleTheValue(item.item.price-promoAmount) * 100) / 100);
                  } else {
                    points = points+(Math.round($ctrl.doubleTheValue(item.item.price) * 100) / 100) * (item.quantity-1);
                    points = points+(Math.round($ctrl.doubleTheValue(item.item.price-promoAmount)* 100) / 100);
                  }
                }
                else {
                  if(item.subCategory.category.dscCategory){
                    points = points+(Math.round((0.85 * item.item.price) * 100) / 100) * (item.quantity-1);
                    points = points+(item.item.price-promoAmount);
                  } else {
                    points = points+(Math.round((item.item.price) * 100) / 100) * (item.quantity-1);
                    points = points+(item.item.price-promoAmount);
                  }
                  // console.log("item ND"+item.item.name+" : "+item.item.subCategory.category.dscCategory + "Points: "+ points);
                }
              }
            } else {
              if(item.item.masterProduct.applyDscPoints){
                if(storeDiscountMap.status && item.item.masterProduct.applyDoubleDSCPoints){
                  if(item.subCategory.category.dscCategory){
                    points = points+(Math.round($ctrl.doubleTheValue(0.85 * item.item.price) * 100) / 100) * (item.quantity);
                  } else {
                    points = points+(Math.round($ctrl.doubleTheValue(item.item.price) * 100) / 100) * (item.quantity);
                  }
                }
                else {
                  if(item.subCategory.category.dscCategory){
                    points = points+(Math.round(0.85 * (item.item.price) * 100) / 100) * (item.quantity);
                  } else {
                    points = points+(Math.round((item.item.price) * 100) / 100) * (item.quantity);
                  }
                }
              } 
            }
          });
        }
    }
    // update end
    else {
      let dscItems = this.detail.cartItems.filter(item => item.subCategory.category.dscCategory);
      let nondscItems = this.detail.cartItems.filter(item => !item.subCategory.category.dscCategory);
      $ctrl = this;
          dscItems.forEach(item => {
              if(item.item.masterProduct.applyDscPoints){
                if(storeDiscountMap.status && item.item.masterProduct.applyDoubleDSCPoints){
                    dscTotal = dscTotal+(Math.round($ctrl.doubleTheValue(0.85 * item.item.price) * 100) / 100) * item.quantity;
                } else {
                  dscTotal = dscTotal+ (Math.round((0.85 * item.item.price) * 100) / 100) * item.quantity;
                }
              }
            }
          );

          nondscItems.forEach(item => {
              if(item.item.masterProduct.applyDscPoints){
                if(storeDiscountMap.status && item.item.masterProduct.applyDoubleDSCPoints){
                  nonDscTotal = nonDscTotal+(Math.round($ctrl.doubleTheValue(item.item.price) * 100) / 100) * item.quantity;
                } else {
                  nonDscTotal = nonDscTotal+(Math.round((item.item.price) * 100) / 100) * item.quantity;
                }
              }
            }
          );
          points = dscTotal + nonDscTotal;
        }
    return points;
  }

  doubleTheValue(value){
    return value*2;
  }

  getDSCItemFromCart() {
    let dscItem = '';
    this.detail.cartItems.forEach(item => {
      if(item.item.masterProduct.masterCode === this.dscMasterCode){
       dscItem = item.item;
      }
    });
    return dscItem;
  }

  validateBBCoupon(){
    if (this.couponAmount >= this.getSubtotal()) {
      this.isValidToApplyBB = false;
    }
    else if(this.getDSCItemFromCart()){
      if (this.couponAmount >= this.getSubtotal()-this.discountCouponAmount-this.getDSCItemFromCart().price){
        this.isValidToApplyBB = false;
      } else {
        this.isValidToApplyBB = true;
      }
    } else {
      this.isValidToApplyBB = true;
    }
  }

  validatePromoCoupon(){
    if (this.discountCouponAmount >= this.getSubtotal()) {
      this.isValidToApplyPromo = false;
    }
    else if(this.getDSCItemFromCart()){
      if (this.discountCouponAmount >= this.getSubtotal()-this.couponAmount-this.getDSCItemFromCart().price){
        this.isValidToApplyPromo = false;
      } else {
        this.isValidToApplyPromo = true;
      }
    } else {
      this.isValidToApplyPromo = true;
    }


  }
  getClubPointsOld() {
    return this.orderPoints.dscPoints;
    // return 12;
  }
  calculateClubPoints() {
    this.appliedDiscountCoupon=  sessionStorage.getItem('discountCoupon');
    this.appliedBirdBuckCoupon=  sessionStorage.getItem('birdbuckCoupon');
    var isInStorePickUp = true;
    var shipToStateId;
      if(this.$rootScope.tempdeliveryMode){
        if(this.$rootScope.tempdeliveryMode!==''){
          isInStorePickUp = this.$rootScope.tempdeliveryMode==='In Store Pickup'?true:false;
          shipToStateId = this.getShipToStateId(isInStorePickUp);
        } else {
          shipToStateId = this.getShipToStateId(true);
        }
      }
    var data ={
      'bbcouponId':this.appliedBirdBuckCoupon ? this.appliedBirdBuckCoupon : null,
	    'discountcoupon':  this.appliedDiscountCoupon ? this.appliedDiscountCoupon  : null,
      'isInStorePickUp': isInStorePickUp,
      'shipToStateId' : shipToStateId
    };
    this.$order.getOrderPoints(data).then(
      success => {
        if(this.appliedDiscountCoupon){
          this.discountCouponAmount=this.orderPoints.discountWrapper.couponAmount;
        } else {
            this.discountCouponAmount=0;
        }
        
        if(this.orderPoints && this.orderPoints.discountWrapper && this.orderPoints.discountWrapper.discountType === 'FREEITEM') {
          if (this.orderPoints.discountWrapper.cartItemset && this.orderPoints.discountWrapper.cartItemset.length) {
             this.discountFreeItemId = this.orderPoints.discountWrapper.cartItemset ? this.orderPoints.discountWrapper.cartItemset.find(ele => ele.discountTypeApplied === 'FREEITEM' && ele.isDiscountApplied && this.orderPoints.discountWrapper.couponAmount) : null;
             if (this.discountFreeItemId && this.discountFreeItemId.item) {
              this.discountFreeItemId = this.discountFreeItemId.item.id;
             }
          } else {
            this.discountFreeItemId = null;
          }
        }

        if(this.orderPoints && this.orderPoints.discountWrapper && this.orderPoints.discountWrapper.discountType === 'BUYXGETY') {
          if (this.orderPoints.discountWrapper.cartItemset && this.orderPoints.discountWrapper.cartItemset.length) {
             this.discountFreeItemId = this.orderPoints.discountWrapper.cartItemset ? this.orderPoints.discountWrapper.cartItemset.find(ele => ele.discountTypeApplied === 'BUYXGETY' && ele.isDiscountApplied && this.orderPoints.discountWrapper.couponAmount) : null;
             if (this.discountFreeItemId && this.discountFreeItemId.item) {
              this.discountFreeItemId = this.discountFreeItemId.item.id;
             }
          } else {
            this.discountFreeItemId = null;
          }
        }
      })
      .catch(err => {
        this.$auth.printCustomerGenericLogs(err);
      });
  }

  getShipToStateId(isInStorePickUp){
    if(isInStorePickUp){
      return this.profile.store.storeId;
    } else {
      return  this.addressDetail.shippingState.id;
    }
  }

  deliveryTypeValidation() {    
    if (this.detail && this.detail.cartItems && this.detail.cartItems.length) {
      const pickupExist = this.detail.cartItems.filter(element => element.item.deliveryType == 'InStore');
      const dropExist = this.detail.cartItems.filter(element => element.item.deliveryType == 'DropShip');
      if (pickupExist && pickupExist.length && dropExist && dropExist.length) {
        return true;
      }
    }
    return false;
  }

  getErplyPromotionInfo(item,key){
    if(this.detail!=null){
      if(this.detail.erplyShopCartResponse!=null && this.detail.erplyShopCartResponse.erplyPromotionDetails){
        if(this.detail.erplyShopCartResponse.erplyPromotionDetails[item.item.id] &&this.detail.erplyShopCartResponse.erplyPromotionDetails[item.item.id].isDscPromo){
          if(key===this.dscPercentage){
            return this.detail.erplyShopCartResponse.erplyPromotionDetails[item.item.id].dscPercentage;
          }
          else if(key==this.dscDiscount){
            return this.detail.erplyShopCartResponse.erplyPromotionDetails[item.item.id].dscDiscount;
          }
          else if(key==this.dscDiscountedPrice){
            return this.detail.erplyShopCartResponse.erplyPromotionDetails[item.item.id].discountedPriced;
          }
        }
      }
    }
  }

  proceedToCheckout() {
    if(this.doPageNeedsToBeRefreshed) {
      this.$window.location.reload();
      return;
    }
    var activeCartItems = this.detail?this.detail.cartItems.filter(item => !(item.isItemRemoved)):[];
    if(this.numberOfItemsAllowedToPurchase < activeCartItems.length) {
      var detailInfo = "An order can have a maximum of 40 items. Please remove some items from the cart to proceed.";
        this.showErrorMsgPopup(detailInfo);
        return;
    }
    

    if (this.isAnyItemInactive()) {
      this.$toaster.pop('success', 'Some items in your cart are temporarily unavailable.  Please remove those items to continue with your purchase.');
    } else {
      this.$state.go('delivery');
    }
  }

  /* AddToCart for interaction studio

  addToCart(quantity, item) {
    console.log("Adding item to cart", item);
    var ctrl = this;
    // Validating instore and Delivery only items in cart
    if (!this.deliveryTypeValidationForInjectingItem(item)) {
      var deliveryError = 'Your cart contains some items that are ' + (item.deliveryType === 'InStore' ? 'delivery' : 'in-store/curbside pickup') + ' only. If you would like to add this item to your cart, please remove those items or complete a separate order.';
      this.$toaster.pop('success', deliveryError);
      return false;
    }

    this.$order.addItemToCart(quantity, item.itemId, item.subCategoryId)
      .then(
        () => {

                this.calculateClubPoints();
                if(this.profile.store.hasErply){
                  if(!this.hasErplyCalShopcartRes){
                    ctrl.hasErplyCalShopcartRes=true;
                    setTimeout(function(){
                      // console.log("Inside set time ctrl.startMicroSecs : ",ctrl.startMicroSecs);
                      ctrl.$spinner.show('appSpinner');
                      ctrl.$order.getCartDetail().then(() => {
                        ctrl.hasErplyCalShopcartRes=false;
                        ctrl.$spinner.hide('appSpinner');
                        ctrl.startMicroSecs=ctrl.baseMicroSecs;
                      })
                      .catch(() => {
                        ctrl.hasErplyCalShopcartRes=false;
                        ctrl.startMicroSecs=ctrl.baseMicroSecs;
                        ctrl.$spinner.hide('appSpinner');
                      });
                    },ctrl.startMicroSecs);
                    // console.log("After set time call, ctrl.startMicroSecs: ", this.startMicroSecs);
                  }
                } else {
                  ctrl.$order.getCartDetail();
                }
                this.$auth.getUserProfile();
          this.$toaster.pop('success', 'Item added to cart');
        },
        error => {
          if (error.data.errorCode == 692) {
            this.$toaster.pop('success', error.data.message);
          }
          else {
            this.$toaster.pop('success', 'Item already exists in cart');
          }
        }
      )
      .finally(() => {
        // Console.log("Check if we need to do something");
      }
      );
  }

  */

  deliveryTypeValidationForInjectingItem(item) {
      if(item.isOutOfStock) {
        return false;
      }
      if (this.detail && this.detail.cartItems && this.detail.cartItems.length) {
      const pickupExist = this.detail.cartItems.filter(element => element.item.deliveryType == 'InStore');
      const dropExist = this.detail.cartItems.filter(element => element.item.deliveryType == 'DropShip');
      if (pickupExist && pickupExist.length && dropExist && dropExist.length) {
        return false;
      }
      else if(item.deliveryType == 'InStore' && dropExist && dropExist.length){
        return false;
      }
      else if(item.deliveryType == 'DropShip' && pickupExist && pickupExist.length){
        return false;
      }
    }
    return true;
  }

  getFinalPriceInfo(item){
    if(this.detail!=null){
      if(this.detail.erplyShopCartResponse!=null && this.detail.erplyShopCartResponse.erplyItemDetails){
        if(this.detail.erplyShopCartResponse.erplyItemDetails[item.item.storeItemCode]){
            return this.detail.erplyShopCartResponse.erplyItemDetails[item.item.storeItemCode].finalPriceOfItem;
        }
      }
    }
  }

  setErplyCartResponseValue(success){
    this.erplyDis = [];
    var dis ={};
    var ctrl = this;
    var i = 0;
    console.log(this.detail.erplyPromoAndDiscount);
    console.log("this.detail.promotionsAppliedOnItems",this.detail.promotionsAppliedOnItems);

    if(ctrl.detail.promotionsAppliedOnItems) {
      angular.forEach(ctrl.detail.promotionsAppliedOnItems, function (id,value) {
        console.log('value', value);
        angular.forEach(ctrl.detail.cartItems, function(item) {
          if(item.item.masterProduct.masterCode == value){
              item.item.promotionsAppliedOnItems = id;
            }
          });
      });
      // console.log(this.detail.cartItems);
    }
    angular.forEach(this.detail.erplyPromoAndDiscount, function (item,key) {
      dis ={};
      console.log('key', key);
      console.log('item', item);
      dis.key = key;
      dis.value = item;
      dis.sortId = i+1;
      i=i+1;
      ctrl.erplyDis.push(dis);
    });
    console.log("Cart - ctrl.erplyDis", ctrl.erplyDis);
  }

  getAdjustedLabelName(promoLabel) {
    if(promoLabel!=null && promoLabel.length>this.promoLengthToBeShown){
      return promoLabel.substring(0, this.promoLengthToBeShown-3)+"...";
    } else {
      return promoLabel;
    }
  }

  hideinfoPopup(prefix,index, itemName, promoName) {
    var divId = "";
    if(itemName!=null){
      divId = prefix+''+index+''+itemName+''+promoName;
    } else {
      divId =prefix+''+index+''+ promoName;
    }
    document.getElementById(divId).style.display = 'none';
    this.showPopup = false;
  }

  infoPopuponhover(prefix,index, itemName, promoName) {
    var divId = "";
    if(itemName!=null){
      divId = prefix+''+index+''+itemName+''+promoName;
    } else {
      divId =prefix+''+index+''+ promoName;
    }
    document.getElementById(divId).style.display = 'block';
    this.showPopup = true;
  }

  showErrorMsgPopup(detailInfo){
      this.$uibModal.open( {
        size: 'sm',
        template: '<div class="modal-body" id="modal-body">' +
        '<h5 class="font-weight-bold"> </h5>' +
        detailInfo +
        '</div>' +
        '<div class="modal-footer">' +
        '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' +
        '</div>',
        controller: ['$scope', 'orderService', '$uibModalInstance',
          function($scope, $order, $uibModalInstance) {
  
            $scope.ok = () => {
              $uibModalInstance.close();
            };
  
          }
        ]
      });
  }

  userAction(userAction){
    this.$order.updateUserAction(userAction);
  }

}



// WEBPACK FOOTER //
// ./src/app/order/cart/cart.js